import {
  Breadcrumb
} from '@/types'

export const regStepEnabled = (step: Breadcrumb) => {
  return window.parameters.registration_flow_steps.includes(step) ? [step] : []
}